module.exports = __webpack_public_path__ + "img/Jump Casting117.0538ff9b.jpg";